<template>
    <div class="template_home">
        <div class="one1">
            <earthCavas />
        </div>
        <div class="home one2">
            <div class="homeTitle">
                <div class="name">核心服务</div>
            </div>
            <div class="explain">COER SERVICES</div>
            <div class="homeContent">
                <div class="homeContent_one2">
                    <div class="item wow animate__animated animate__bounceIn" :data-wow-delay ="item.time+'s'" v-for="(item,index) in one2Data" :key="index">
                        <div class="left">
                            <span class="name">{{item.title}}</span>
                            <i class="nameIcon iconfont" :class="item.titleIcon"></i>
                        </div>
                        <div class="right">
                            <div class="li" v-for="(em,ind) in item.list" :key="ind">
                                <img :src="em.icon" alt="">
                                <span class="text">{{em.name}}</span>
                            </div>
                        </div>
                        <div class="item_fottor">
                            进一步了解  <i class="iconfont iconlejiegengduo"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home one3">
            <div class="homeContent homeContent_one3 wow animate__animated animate__fadeInUpBig" data-wow-duration ="0.5s" data-wow-delay ="0.4s">
                <div class="text">行业首创，多系统集成在线协同，多维度解决木材行业痛点</div>
                <div class="text">全方位赋能木材全产业链企业数字化管理运营</div> 
                <div class="one3Back">
                    <service />
                </div>
            </div>
        </div>
        <div class="home one5">
            <div class="homeTitle">
                <div class="name">视频介绍</div>
            </div>
            <div class="explain">VIDEO INTRODUCTION</div>
            <div class="homeContent_one4">
                <video class="contentMovie" poster="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back35.png" preload="load" controls="controls" x-webkit-airplay="true" x5-playsinline="true" webkit-playsinline="true" playsinline="true">
                    <source src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/%E5%BE%B7%E6%9C%A8.mp4" type="video/mp4">
                    <source src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/%E5%BE%B7%E6%9C%A8.mp4" type="video/ogg">
                    抱歉，您的浏览器不支持视频播放
                </video>
            </div>
        </div>
        <div class="home one5">
            <div class="homeTitle">
                <div class="name">合作伙伴</div>
            </div>
            <div class="explain">COOPERATIVE PARTNER</div>
            <div class="homeContent" >
                <div class="homeContent_one5">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="合作机构" name="cooperation">
                            <cooperation />
                        </el-tab-pane>
                        <el-tab-pane label="友情链接" name="link"></el-tab-pane>
                    </el-tabs>
                </div>    
            </div>
        </div>
    </div>
</template>
<script>
    import {WOW} from 'wowjs'
    import earthCavas from './components/earthCavas'
    import service from './components/service'
    import cooperation from './components/cooperation'
    export default {
        components:{
            earthCavas,
            service,
            cooperation
        },
        data(){
            return{
                one2Data:[
                    {
                        title:'企业管理数字化',
                        titleIcon:'iconqiyeguanlishuzihua',
                        time:0.8,
                        list:[
                            {
                                name:'德木ERP系统',
                                icon:require('@/assets/icon/5.png'),
                            },
                            {
                                name:'德木云仓MS系统',
                                icon:require('@/assets/icon/7.png'),
                            },
                            {
                                name:'车辆QMS系统',
                                icon:require('@/assets/icon/3.png'),
                            },
                            {
                                name:'谱木云ERP系统',
                                icon:require('@/assets/icon/14.png'),
                            }
                        ]
                    },
                    {
                        title:'金融服务在线化',
                        titleIcon:'iconjinrongfuwuzaixianhua',
                        time:0.6,
                        list:[
                            {
                                name:'德木金融FS系统',
                                icon:require('@/assets/icon/6.png'),
                            },
                            {
                                name:'现货融',
                                icon:require('@/assets/icon/20.png'),
                            },
                            {
                                name:'代赎货',
                                icon:require('@/assets/icon/4.png'),
                            },
                            {
                                name:'订单融',
                                icon:require('@/assets/icon/8.png'),
                            }
                        ]
                    },
                    {
                        title:'运营决策数据化',
                        titleIcon:'iconyunyingjueceshujuhua',
                        time:0.4,
                        list:[
                            {
                                name:'在途资源大数据',
                                icon:require('@/assets/icon/22.png'),
                            },
                            {
                                name:'现货库存大数据',
                                icon:require('@/assets/icon/19.png'),
                            },
                            {
                                name:'进出货量大数据',
                                icon:require('@/assets/icon/11.png'),
                            },
                            {
                                name:'市场行情大数据',
                                icon:require('@/assets/icon/17.png'),
                            }
                        ]
                    },
                    {
                        title:'一站式在线协同服务',
                        titleIcon:'iconzaixianxietongfuwu',
                        time:0.2,
                        list:[
                            {
                                name:'在线船代货代服务',
                                icon:require('@/assets/icon/24.png'),
                            },
                            {
                                name:'在线仓储物流服务',
                                icon:require('@/assets/icon/23.png'),
                            },
                            {
                                name:'在线企业管理服务',
                                icon:require('@/assets/icon/26.png'),
                            },
                            {
                                name:'在线金融服务',
                                icon:require('@/assets/icon/25.png'),
                            },
                            {
                                name:'在线信息服务',
                                icon:require('@/assets/icon/27.png'),
                            }
                        ]
                    }
                ],
                activeName:'cooperation',
                
            }
        },
        mounted(){
            this.$nextTick(() => {
                let wow = new WOW({
                    boxClass: "wow",    //需要执行动画的元素的 class
                    animateClass: "animated", // animation.css 动画的 class
                    offset: 0, // 距离可视区域多少开始执行动画
                    mobile: false, // 是否在移动设备上执行动画
                    live: false // 异步加载的内容是否有效
                })
                wow.init()
            })
        },
        methods:{

        }
    }
</script>
<style scoped  lang="scss">
    .home1{width: 100%;}

	.template_home{display: flex;justify-content: center;align-items: center; flex-direction: column;overflow: hidden;}
    .one1{width: 100%;height: 100%;}
    .template_home .home{width: 100%;}

    .homeTitle{border-bottom: 1px solid #E5E6EB;text-align: center;margin-top: 3rem;}
    .homeTitle .name{margin: 0 auto;margin-bottom:3px;line-height: 4.5rem;letter-spacing:0.1rem; font-size: 2.3rem;font-weight: 600;color: #333333;position: relative;}
    .homeTitle .name:after{content: '';width: 10rem;height: 2.7rem;background: #CEDCFF;display: block;border-radius: 0.5rem;transform: translateX(-50%);position: absolute;bottom: 0;left: 51.5%;z-index: -1;}
    .explain{text-align: center;color: #999999;}
    .homeContent{max-width: 120rem;margin: 0 auto;padding: 3rem 1rem;}
    .titmeName{text-align: center;margin: 1rem 0 0 0;}
    .titmeName .title{color: #333;font-weight: 600;font-size: 2.4rem;margin-bottom: 0.5rem;}
    .titmeName .explainTitle{color: #999999;font-weight: 600;font-size: 1.4rem;line-height: 2rem;}

    .homeContent_one2{display: flex;flex-direction: row;justify-content: space-between;}
    .homeContent_one2 .item{display: flex;flex: 1; flex-direction: column;text-align: left;margin: 0 1rem;background: #FFFFFF;box-shadow: 0 0 2.9rem 0 rgba(117, 117, 117, 0.42);border-radius: 0.4rem;}
    .homeContent_one2 .item:first-child{margin-left: 0;}
    .homeContent_one2 .item:last-child{margin-right: 0;}
    .homeContent_one2 .item{transition: all .6s;}
    .homeContent_one2 .item:hover{transform: translateY(-2rem);cursor: pointer;}
    .homeContent_one2 .item .left{display: flex;align-items: center;background: linear-gradient(270deg, #7D9FF4 0%, #4D78E3 100%);padding: 1rem;border-top-left-radius: 0.4rem;border-top-right-radius: 0.4rem;}
    .homeContent_one2 .item .left .name{flex: 1;color: #fff;font-weight: 500;font-size: 1.6rem;}
    .homeContent_one2 .item .left .nameIcon{font-size: 5rem;color: #5c80dd;}
    .homeContent_one2 .item .right{padding: 2rem;height: 30rem;display: flex;align-items: flex-start;flex-direction: column;justify-content: center;}
    .homeContent_one2 .item .right .li{display: flex;align-items: center;}
    .homeContent_one2 .item .right .li:last-child{border-bottom: 0;}
    .homeContent_one2 .item .right .li img{margin-right: 2rem;padding: 1.5rem 0;width: 4rem;}
    .homeContent_one2 .item .right .li .text{color: #333;font-size: 14px;}
    .homeContent_one2 .item .item_fottor{border-top: 1px solid #e0e1e5;padding: 1.5rem 2rem;color: #5784F4;font-size: 1.4rem;}

    .homeContent_one3{text-align: center;width: 100%;height: 63rem;overflow: hidden;}
    .homeContent_one3 .text{text-align: center;color: #333333;font-weight: 600; margin-bottom: 1rem;font-size: 1.6rem;}
    .one3Back{width: 100%;height: 50rem;margin: 3rem 0;}

    .homeContent_one4{
        height: 63rem;
        width: 120rem;
        border-radius: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 2rem auto 0 auto;
        overflow: hidden;
        .contentMovie{width: 120rem;height: 69rem;cursor: pointer;}
    }

    .homeContent_one5 .el-tabs{width: 100%;}
    .homeContent_one5{display: flex;flex-direction: row;justify-content: space-between;overflow:hidden;}
</style>